
import React from 'react';
import { UseFormReturn } from 'react-hook-form';
import { format } from 'date-fns';
import {
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from '@/components/ui/form';
import { Input } from '@/components/ui/input';
import { Textarea } from '@/components/ui/textarea';
import { EstimateFinalStepValues } from '../types/estimateFormTypes';

interface EstimateFinalStepFieldsProps {
  form: UseFormReturn<EstimateFinalStepValues>;
  sentDate?: string;
  createdAt?: string;
  estimateStatus?: string;
}

const EstimateFinalStepFields: React.FC<EstimateFinalStepFieldsProps> = ({ form, sentDate, createdAt, estimateStatus }) => {
  const validityDays = form.watch('validity_period');
  const anchorDate = sentDate
    ? new Date(sentDate)
    : new Date(createdAt || Date.now());
  const previewExpiry = new Date(
    anchorDate.getTime() + (validityDays * 24 * 60 * 60 * 1000)
  );

  return (
    <div className="space-y-6">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <FormField
          control={form.control}
          name="special_instructions"
          render={({ field }) => (
            <FormItem>
              <FormLabel>Special Instructions</FormLabel>
              <FormControl>
                <Textarea
                  placeholder="Add any special instructions for this estimate"
                  {...field}
                />
              </FormControl>
              <FormMessage />
            </FormItem>
          )}
        />

        <FormField
          control={form.control}
          name="payment_terms"
          render={({ field }) => (
            <FormItem>
              <FormLabel>Payment Terms</FormLabel>
              <FormControl>
                <Textarea
                  placeholder="Specify payment terms and conditions"
                  {...field}
                />
              </FormControl>
              <FormMessage />
            </FormItem>
          )}
        />
      </div>

      <FormField
        control={form.control}
        name="validity_period"
        render={({ field }) => (
          <FormItem>
            <FormLabel>Validity Period (days)</FormLabel>
            <FormControl>
              <Input
                type="number"
                max="365"
                {...field}
                onChange={e => {
                  const val = e.target.value;
                  if (val === '') field.onChange('');
                  else { const num = parseInt(val); if (!isNaN(num)) field.onChange(num); }
                }}
                onBlur={e => {
                  const num = parseInt(e.target.value);
                  if (isNaN(num) || num < 1) {
                    field.onChange(14);
                  } else if (num > 365) {
                    field.onChange(365);
                  }
                }}
              />
            </FormControl>
            <p className="text-sm text-muted-foreground mt-1">
              Expires: {format(previewExpiry, 'dd MMMM yyyy')}
            </p>
            <FormMessage />
          </FormItem>
        )}
      />
    </div>
  );
};

export default EstimateFinalStepFields;
